<template>
  <div>
    <v-card class="mx-2 px-2">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Dashboard</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-alert color="purple" dark dismissible outlined
          >Los indicadores de Turnos están tomadas en base al estado de los
          mismos. Para más información puede consultar el video tutorial donde
          se explica el manejo de los estados de los turnos.</v-alert
        >
        <v-row>
          <v-col cols="12" md="4" sm="6">
            <v-select
              :items="profsBuscar"
              item-text="nombreProfesional"
              item-value="idProfesional"
              menu-props="auto"
              label="Profesional"
              hide-details
              prepend-icon="mdi-account"
              v-model="prof"
              dense
              ref="vselect"
              no-data-text="No hay Profesionales configurados"
              @change="recargarIndicadores"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="6">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="datesFormatted"
                  label="Fecha desde / hasta"
                  readonly
                  v-on="on"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                locale="es-ar"
                range
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Totales</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.totales }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Total de turnos del mes, incluye hasta el último día del mes y
              todos los estados</span
            >
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                v-bind="attrs"
                v-on="on"
                color="cyan"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Atendidos</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.atendidos }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span>Turnos que ya fueron atendidos por el profesional</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Ausentes</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.ausentes }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Turnos que quedaron en estado reservado y que son anteriores a la
              fecha actual</span
            >
          </v-tooltip>
        </v-row>

        <v-row>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos En Espera</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.espera }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span>Turnos en estado "Paciente en Sala de Espera"</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Reservados</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.reservados }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Turnos que están en estado reservado y cuya fecha es igual o
              mayor a la fecha actual</span
            >
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                color="cyan"
                v-bind="attrs"
                v-on="on"
                dark
                class="mt-4 mx-auto"
                height="120"
                width="260"
              >
                <v-list-item four-line>
                  <v-list-item-content>
                    <div class="overline mb-4">
                      <v-row class="ml-0 mb-2">
                        <v-icon>mdi-calendar</v-icon>
                        <h4 class="ml-2">Turnos Web</h4>
                      </v-row>
                      <v-row class="ml-0"></v-row>
                      <v-row class="mr-0 pr-0">
                        <v-spacer></v-spacer>
                        <h1>{{ indicadores.web }}</h1>
                      </v-row>
                      <v-row>
                        <v-icon class="ml-3">mdi-chart-bar</v-icon>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
            <span
              >Turnos que fueron reservados a través del sitio web, sin tener en
              cuenta su estado</span
            >
          </v-tooltip>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card color="orange" dark class="mt-2 mx-5">
              <v-list-item four-line>
                <v-list-item-content>
                  <div class="overline mb-4">
                    <v-row class="ml-0 mb-2">
                      <v-icon>mdi-currency-usd</v-icon>
                      <h4 class="ml-2">Ingresos</h4>
                    </v-row>
                    <v-row class="ml-0"></v-row>
                    <v-row class="mr-0 pr-0">
                      <v-spacer></v-spacer>
                      <h1>${{ indicadores.ingresos }}</h1>
                    </v-row>
                    <v-row>
                      <v-icon class="ml-3">mdi-chart-bar</v-icon>
                    </v-row>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="turnoshorario.length">
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#1a6b8a" dark>
              <v-card-title>
                <v-icon large left>mdi-clock-outline</v-icon>
                <span class="title font-weight-light">
                  Distribución de Turnos por Franja Horaria
                </span>
              </v-card-title>
              <v-card-text>
                <div style="overflow-x: auto">
                  <div
                    :style="{
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: '2px',
                      height: '190px',
                      minWidth: turnoshorario.length * 14 + 'px',
                      paddingBottom: '32px',
                      position: 'relative',
                    }"
                  >
                    <!-- Linea de base -->
                    <div
                      style="
                        position: absolute;
                        bottom: 32px;
                        left: 0;
                        right: 0;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                      "
                    ></div>

                    <div
                      v-for="(item, i) in turnoshorario"
                      :key="item.rangoHorario"
                      style="
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: flex-end;
                        height: 100%;
                        position: relative;
                        min-width: 12px;
                      "
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            :style="{
                              width: '100%',
                              height: calcBarHeight(item.cantidad) + 'px',
                              background: barColor(item.cantidad),
                              borderRadius: '3px 3px 0 0',
                              marginBottom: '4px',
                              cursor: 'default',
                            }"
                          ></div>
                        </template>
                        <span>
                          {{ item.rangoHorario }} — {{ item.cantidad }} turno{{
                            item.cantidad !== 1 ? "s" : ""
                          }}
                        </span>
                      </v-tooltip>

                      <!-- Etiqueta cada 4 bloques (cada hora en punto) -->
                      <div
                        v-if="i % 4 === 0"
                        style="
                          position: absolute;
                          bottom: -25px;
                          left: 50%;
                          transform: translateX(-50%);
                          font-size: 12px;
                          font-weight: 600;
                          white-space: nowrap;
                          color: #ffffff;
                          letter-spacing: 0.3px;
                        "
                      >
                        {{ item.rangoHorario }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Tabla resumen
                <v-card flat class="mt-2">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead style="background: #1a6b8a">
                        <tr>
                          <th class="text-left" style="color: white">
                            Horario
                          </th>
                          <th class="text-left" style="color: white">
                            Cantidad
                          </th>
                          <th class="text-left" style="color: white">
                            % del total
                          </th>
                        </tr>
                      </thead>
                      <tbody style="background: #1a6b8a">
                        <tr
                          v-for="item in turnoshorario"
                          :key="item.rangoHorario"
                        >
                          <td>{{ item.rangoHorario }}</td>
                          <td>{{ item.cantidad }}</td>
                          <td>{{ porcentaje(item.cantidad) }}%</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card> -->
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="turnospacientes.length">
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#4278f6" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light"
                  >Ranking de ausencias por paciente</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat>
                  <v-simple-table ref="tableAusencias">
                    <template v-slot:default>
                      <thead style="background: #4278f6">
                        <tr>
                          <th class="text-left">Nº</th>
                          <th class="text-left">Paciente</th>
                          <th class="text-left">Ausencias</th>
                        </tr>
                      </thead>
                      <tbody style="background: #4278f6">
                        <tr
                          v-for="(item, i) in turnospacientes"
                          :key="item.paciente"
                        >
                          <td>{{ i + 1 }}</td>
                          <td>{{ item.paciente }}</td>
                          <td>{{ item.ausencias }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="turnosos.length">
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#b829de" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light"
                  >Ranking de turnos por obra social</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead style="background: #b829de">
                        <tr>
                          <th class="text-left">Nº</th>
                          <th class="text-left">Obra Social</th>
                          <th class="text-left">Turnos</th>
                        </tr>
                      </thead>
                      <tbody style="background: #b829de">
                        <tr
                          v-for="(item, i) in turnosos"
                          :key="item.obrasocial"
                        >
                          <td>{{ i + 1 }}</td>
                          <td>{{ item.obrasocial }}</td>
                          <td>{{ item.turnos }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="turnosedad.length">
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#147536" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light"
                  >Distribución de Turnos Atendidos por Edad</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead style="background: #147536">
                        <tr>
                          <th class="text-left">Nº</th>
                          <th class="text-left">Edad</th>
                          <th class="text-left">Cantidad</th>
                        </tr>
                      </thead>
                      <tbody style="background: #147536">
                        <tr v-for="(item, i) in turnosedad" :key="item.edad">
                          <td>{{ i + 1 }}</td>
                          <td>{{ item.edad }}</td>
                          <td>{{ item.cantidad }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="turnosedadmenores.length">
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#00796B" dark>
              <v-card-title>
                <v-icon large left>mdi-baby-face-outline</v-icon>
                <span class="title font-weight-light"
                  >Atendidos hasta 1 año por Rango de Edad</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead style="background: #00796B">
                        <tr>
                          <th class="text-left">Nº</th>
                          <th class="text-left">Rango de Edad</th>
                          <th class="text-left">Cantidad</th>
                        </tr>
                      </thead>
                      <tbody style="background: #00796B">
                        <tr
                          v-for="(item, i) in turnosedadmenores"
                          :key="item.edad"
                        >
                          <td>{{ i + 1 }}</td>
                          <td>{{ item.edad }}</td>
                          <td>{{ item.cantidad }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <v-row class="mt-2">
                  <v-col cols="12" class="text-right">
                    <v-chip color="white" text-color="#00796B" label small>
                      Total: {{ totalMenores }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="turnospatologia.length">
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#3F79D7" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light"
                  >Distribución de Turnos Atendidos por Patología</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead style="background: #3f79d7">
                        <tr>
                          <th class="text-left">Nº</th>
                          <th class="text-left">Patología</th>
                          <th class="text-left">Cantidad</th>
                        </tr>
                      </thead>
                      <tbody style="background: #3f79d7">
                        <tr
                          v-for="(item, i) in turnospatologia"
                          :key="item.nombrePatologia"
                        >
                          <td>{{ i + 1 }}</td>
                          <td>{{ item.nombrePatologia }}</td>
                          <td>{{ item.cantidad }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="turnosprofesional.length">
          <v-col cols="12">
            <v-card class="mt-2 mx-5" color="#b30941" dark>
              <v-card-title>
                <v-icon large left>mdi-chart-bar</v-icon>
                <span class="title font-weight-light"
                  >Pacientes por profesional</span
                >
              </v-card-title>
              <v-card-text>
                <v-card flat>
                  <v-simple-table
                    fixed-header
                    height="300px"
                    style="background: #b30941"
                  >
                    <template v-slot:default>
                      <thead style="background: #b30941">
                        <tr>
                          <th class="text-left" style="background: #b30941">
                            Profesional
                          </th>
                          <th class="text-left" style="background: #b30941">
                            Total Turnos
                          </th>
                          <th class="text-left" style="background: #b30941">
                            Reservados
                          </th>
                          <th class="text-left" style="background: #b30941">
                            En Espera
                          </th>
                          <th class="text-left" style="background: #b30941">
                            Atendidos
                          </th>
                        </tr>
                      </thead>
                      <tbody style="background: #b30941">
                        <tr
                          v-for="(item, i) in turnosprofesional"
                          :key="item.nombreProfesional"
                        >
                          <td>{{ item.nombreProfesional }}</td>
                          <td>{{ item.cantTotal }}</td>
                          <td>{{ item.cantReservados }}</td>
                          <td>{{ item.cantEnEspera }}</td>
                          <td>{{ item.cantAtendidos }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="primary"
          @click.stop="recargarIndicadores"
          :loading="loading"
          :disabled="loading"
        >
          <v-icon left class="mx-1">mdi-refresh</v-icon>Actualizar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click.stop="imprimir">Imprimir</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.stop="salir">Salir</v-btn>
      </v-card-actions>
      <ImprimirDashboard
        :visible="showImprimirDashboard"
        :nomProf="nomProf"
        :mesFormatted="mesFormatted"
        :indicadores="indicadores"
        :turnospacientes="turnospacientes"
        :turnosos="turnosos"
        :turnosedad="turnosedad"
        :turnospatologia="turnospatologia"
        :turnosprofesional="turnosprofesional"
        @close="showImprimirDashboard = false"
      ></ImprimirDashboard>
    </v-card>
  </div>
</template>
<script>
import axios from "../../axios-auth.js";
import router from "../../router/index.js";
import ImprimirDashboard from "../Estadisticas/ImprimirDashboard.vue";
import moment from "moment";

export default {
  data: (vm) => ({
    turnoshorario: [],
    hoveredBar: null,
    showImprimirDashboard: false,
    profsBuscar: [],
    nomProf: "",
    prof: "",
    menu: false,
    modal: false,
    menu2: false,
    dates: [],
    datesFormatted: "",
    turnospacientes: [],
    turnosos: [],
    turnosedad: [],
    turnosedadmenores: [],
    turnospatologia: [],
    turnosprofesional: [],
    loading: false,
    indicadores: {
      totales: "",
      atendidos: "",
      ausentes: "",
      espera: "",
      web: "",
      ingresos: "",
      reservados: "",
    },
  }),
  computed: {
    mesFormatted() {
      return `${this.datesFormatted}`;
    },
    totalMenores() {
      return this.turnosedadmenores.reduce((acc, item) => acc + item.cantidad, 0);
    },
  },
  methods: {
    calcBarHeight(cantidad) {
      const max = Math.max(...this.turnoshorario.map((x) => x.cantidad), 1);
      return Math.round((cantidad / max) * 120) + 5;
    },
    barColor(cantidad) {
      const max = Math.max(...this.turnoshorario.map((x) => x.cantidad), 1);
      const ratio = cantidad / max;
      if (ratio >= 0.75) return "#00e5ff";
      if (ratio >= 0.5) return "#29b6f6";
      if (ratio >= 0.25) return "#4fc3f7";
      return "#81d4fa";
    },
    porcentaje(cantidad) {
      const total = this.turnoshorario.reduce((a, b) => a + b.cantidad, 0);
      if (!total) return "0.0";
      return ((cantidad / total) * 100).toFixed(1);
    },
    recargarRankingHorario() {
      this.turnoshorario = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Dashboard/RecargarRankingHorario?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          // Generar todas las franjas de 00:00 a 23:45 (96 bloques)
          const todasLasFranjas = [];
          for (let minutos = 0; minutos < 24 * 60; minutos += 15) {
            const hh = String(Math.floor(minutos / 60)).padStart(2, "0");
            const mm = String(minutos % 60).padStart(2, "0");
            todasLasFranjas.push(`${hh}:${mm}`);
          }

          // Mapear la respuesta del SP a un diccionario para busqueda rapida
          const datosMap = {};
          if (response.data && response.data.length) {
            response.data.forEach((item) => {
              datosMap[item.rangoHorario] = item.cantidad;
            });
          }

          // Combinar: todas las franjas con cantidad 0 si no hay datos
          self.turnoshorario = todasLasFranjas.map((franja) => ({
            rangoHorario: franja,
            cantidad: datosMap[franja] || 0,
          }));
        })
        .catch(function (error) {});
    },
    setInitialDates() {
      const primerDiaMes = moment().startOf("month").format("YYYY-MM-DD");
      const diaActual = moment().format("YYYY-MM-DD");
      this.dates = [primerDiaMes, diaActual];
    },
    recargarIndicadores() {
      this.loading = true;
      this.recargarDashboard();
      this.recargarRankingPacientes();
      this.recargarRankingOS();
      this.recarcarRankingEdad();
      this.recargarRankingEdadMenores();
      this.recargarRankingPatologias();
      this.recargarRankingTurnosProfesional();
      this.recargarRankingHorario();
      this.loading = false;
    },
    recargarDashboard() {
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarDashboard?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.indicadores = response.data;
          else self.indicadores = {};
        })
        .catch(function (error) {});
    },
    recargarRankingPacientes() {
      this.turnospacientes = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingPacientes?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnospacientes = response.data;
          else self.turnospacientes = [];
        })
        .catch(function (error) {});
    },
    recargarRankingOS() {
      this.turnosos;
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingOs?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnosos = response.data;
          else self.turnosos = [];
        })
        .catch(function (error) {});
    },
    recarcarRankingEdad() {
      this.turnosedad = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingEdad?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnosedad = response.data;
          else self.turnosedad = [];
        })
        .catch(function (error) {});
    },
    recargarRankingEdadMenores() {
      this.turnosedadmenores = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingEdadMenores?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnosedadmenores = response.data;
          else self.turnosedadmenores = [];
        })
        .catch(function (error) {});
    },
    recargarRankingPatologias() {
      this.turnospatologia = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingPatologias?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnospatologia = response.data;
          else self.turnospatologia = [];
        })
        .catch(function (error) {});
    },
    recargarRankingTurnosProfesional() {
      this.turnosprofesional = [];
      const filtrosData = {
        idProfesional: this.prof,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Dashboard/RecargarRankingTurnosProfesional?", {
          params: {
            idProfesional: filtrosData.idProfesional,
            fechaDesde: filtrosData.fechaDesde,
            fechaHasta: filtrosData.fechaHasta,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.turnosprofesional = response.data.map((item) => ({
              ...item,
              cantTotal:
                item.cantReservados + item.cantEnEspera + item.cantAtendidos,
            }));
          else self.turnosprofesional = [];
        })
        .catch(function (error) {});
    },
    salir() {
      router.push({ path: "/Home" });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    imprimir() {
      this.nomProf = this.$refs.vselect.selectedItems[0].nombreProfesional;
      this.showImprimirDashboard = true;
    },
  },
  created() {
    const profData = {
      usuario: this.$store.state.usuario.usuario,
      idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
    };
    let self = this;
    axios
      .get("/Turnos/BuscarProfesionalesAsociados?", {
        params: {
          usuario: profData.usuario,
          idInstitucion: profData.idInstitucion,
        },
      })
      .then((response) => {
        self.profsBuscar = response.data.profesionales;
        if (self.profsBuscar.length > 1)
          self.profsBuscar.unshift({
            idProfesional: 0,
            nombreProfesional: "TODOS",
          });

        self.prof = self.profsBuscar[0].idProfesional;
      });

    this.setInitialDates();
  },

  watch: {
    dates(val) {
      if (val.length === 2) {
        moment.locale("fr");
        this.datesFormatted =
          moment(val[0]).format("L") + " - " + moment(val[1]).format("L");
        this.menu2 = false;
        this.recargarIndicadores();
      }
    },
  },
  components: {
    ImprimirDashboard,
  },
};
</script>
